import { render, staticRenderFns } from "./productWordCard.vue?vue&type=template&id=3f48b44d&scoped=true"
import script from "./productWordCard.vue?vue&type=script&lang=js"
export * from "./productWordCard.vue?vue&type=script&lang=js"
import style0 from "./productWordCard.vue?vue&type=style&index=0&id=3f48b44d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f48b44d",
  null
  
)

export default component.exports